import ReactDOM from 'react-dom';
import { FaqList } from '../components/FaqList';
import { initializeI18n } from '../localization/i18n';

window.renderFaqList = (elementId, props) => {
  const container = document.getElementById(elementId);
  if (container) {

    initializeI18n()
      .then((i18nInstance) => {
        ReactDOM.render(<FaqList props={props} />, container);
      })
      .catch(error => {
        //console.error("Failed to initialize i18n before rendering FaqList:", error);
      });

  } else {
    //console.error(`Element with ID ${elementId} not found.`);
  }
};
